import Textarea from "@adsk/alloy-react-textarea";
import { FieldWrapper } from "@adsk/acc-issues-common/components/primitive/FieldWrapper";
import React, { useCallback } from "react";
import { useTranslations } from "@adsk/acc-issues-translations";
import { CharacterCount } from "../../utils/components/CharacterCount";
export const IssueDeletionCommentField = ({
  value,
  onChange,
  maxCommentLength,
  isCommentTruncated,
}: {
  value: string;
  onChange: (newValue: string) => void;
  maxCommentLength: number;
  isCommentTruncated: boolean;
}) => {
  const { T } = useTranslations();

  const handleChange = useCallback(
    e => {
      onChange(e.target.value);
    },
    [onChange]
  );

  const truncatedDeletedCommentWarning = T.translate(
    "deletedIssues.truncatedDeletedCommentWarning",
    { maxCommentLength }
  ) as string;

  return (
    <>
      <FieldWrapper
        label={T.translate("issueEditForm.delete.commentFieldLabel")}
        errorMessage={
          isCommentTruncated ? truncatedDeletedCommentWarning : undefined
        }
      >
        <div style={{ position: "relative" }}>
          <Textarea
            value={value}
            onChange={handleChange}
            style={{ width: "100%", minHeight: 72 }}
            placeholder={
              T.translate("issueEditForm.delete.commentPlaceholder") as string
            }
            data-testid="delete-comment-field"
            maxHeight={500}
            error={isCommentTruncated}
          ></Textarea>
          <CharacterCount
            count={value.length}
            maxLength={maxCommentLength}
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              padding: `8px 8px`,
            }}
          />
        </div>
      </FieldWrapper>
    </>
  );
};
